import { program } from "../swap";

program.parse(process.argv);
